import { useContext, useEffect, useState } from 'react';
import { BannerContext } from '../../contexts/BannerDimensionsContext';
import Preview from '../preview';
import Stages from './stages';
import './index.css'
import CloseIcon from '@mui/icons-material/Close';
import CompareIcon from '@material-ui/icons/Compare';
import { returnScaleByWidth } from '../../helpers/scaleCalc';
import { Copilot } from './../AI/index';
import usePreviewZoom from '../../hooks/usePreviewZoom';

function Replicates() {
  const { changePreviewZoom } = usePreviewZoom();
  const { listaReplicas,
     replicaActive,
     setReplicaActive,
     mirrorActive,
     setMirrorActive,
     master,
     setFullScreenRight,
     replicate,
     setReplicate,
     setListaReplicas,
     openReplicaContainer,
     fullScreenLeft,
     fullScreenRight,
     setOpenReplicaContainer,
     setTempLine,
     tempLine,
     editGrid,
     setIsBannerActive,
  } = useContext(BannerContext);

  const [ruler, setRuler] = useState({
    totalLeft: 0,
    totalTop: 0,
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    stepScale: 1
  });

  useEffect(() => {
    try {
      let elementRef = document.getElementById(`id-root-stages-${replicaActive}`);
      let containerStageRef = document.getElementById('container-replicates-stages');
      let containerRef = document.getElementById(`id-container-preview-r-${replicaActive}`);
      const stepScale = returnScaleByWidth(
        replicaActive.split('x')[0], 
        replicaActive.split('x')[1], 
        true
      );
      const element = elementRef.getBoundingClientRect();
      const container = containerRef.getBoundingClientRect();
      const containerStage = containerStageRef.getBoundingClientRect();
      setRuler({
        totalLeft: element.left - container.left,
        totalTop: element.top - container.top + 35,
        x: 0,
        y: 0,
        width: (containerStage.width - (element.left - container.left)) / stepScale - 10,
        height: container.height - 200 + (element.top - container.top + 35) + 10,
        stepScale: stepScale
      });
    } catch {
      // Handle errors silently
    }
  }, [replicaActive]);

  const [rulerX_100, setRulerX_100] = useState([]);

  useEffect(() => {
    const newRulerX_100 = Array.from({ length: parseInt((ruler.width) / 100) + 1 }, (_, index) => (
      editGrid ?
      <>
        <div
          key={index}
          style={{
            background: '#888888',
            width: '2px',
            height: '100%',
            position: 'absolute',
            top: 0,
            left: `${(index) * 100 + 30}px`
          }}
        />
      </>
      :
      <></>
    ));
    setRulerX_100(newRulerX_100);
  }, [ruler.width, editGrid]);

  console.log('replicates changed')
  
  const [rulerX_10, setRulerX_10] = useState(() => {
    return Array.from({ length: parseInt((ruler.width - 30) / 10) }, (_, index) => (
      editGrid ?
      <div
        key={index}
        style={{
          background: '#888888',
          width: '2px',
          height: '10px',
          position: 'absolute',
          bottom: 0,
          left: `${(index + 1) * 10 + 30}px`
        }}
      />
      :
      <></>
    ));
  });

  const [rulerY_100, setRulerY_100] = useState(() => {
    return Array.from({ length: parseInt(ruler.height / 100) + 1 }, (_, index) => (
      editGrid ?
      <>
        <div
          key={index}
          style={{
            background: '#888888',
            width: '100%',
            height: '2px',
            position: 'absolute',
            top: `${(index) * 100 + 30}px `,
            left: 0
          }}
        />
      </>
      :
      <></>
    ));
  });

  const [rulerY_10, setRulerY_10] = useState(() => {
    return Array.from({ length: parseInt((ruler.height - 30) / 10) }, (_, index) => (
      editGrid ?
      <div
        key={index}
        style={{
          background: '#888888',
          width: '10px',
          height: '2px',
          position: 'absolute',
          top: `${(index + 1) * 10 + 30}px`,
          right: 0
        }}
      />
      :
      <></>
    ));
  });
    
  const [maxHeight, setMaxHeight] = useState(() => {
    let initialMaxHeight = 0;
    listaReplicas.forEach(element => {
      if (element.height > initialMaxHeight) initialMaxHeight = element.height;
    });
    return initialMaxHeight;
  });

  useEffect(() => {
    let updatedMaxHeight = 0;
    listaReplicas.forEach(element => {
      if (element.height > updatedMaxHeight) updatedMaxHeight = element.height;
    });
    setMaxHeight(updatedMaxHeight);
  }, [listaReplicas]);

  function handleChecked(item, index) {
    var lista = JSON.parse(JSON.stringify(listaReplicas));
    lista[index].pack = !lista[index].pack;
    setListaReplicas(lista);
  }

  function removeReplica(item, index, evt) {
    var copyReplicas = JSON.parse(JSON.stringify(listaReplicas));
    copyReplicas.splice(index, 1);
    if (item.type !== "Custom") {
      var copyFormats = JSON.parse(JSON.stringify(replicate));
      copyFormats.formats.forEach(element => {
        if (element.width === item.width && element.height === item.height ) {
          element.ativo = false;
          let item = document.getElementById(`checkbox${element.width}X${element.height}`);
          if (item) item.checked = element.ativo;
          setReplicate(copyFormats);
        }
      });
    }
    if (copyReplicas.length > 0) setReplicaActive(`${copyReplicas[0].width}x${copyReplicas[0].height}`)
    setListaReplicas(copyReplicas);
    setIsBannerActive(false);
    evt.stopPropagation();
  }

  const [divTabWidth, setDivTabWidth] = useState('1500px');
  const [divRepWidth, setDivRepWidth] = useState('94%');

  useEffect(() => {
    function handleResize() {
        const windowWidth = window.innerWidth;
        if (windowWidth >= 1280 && windowWidth <= 1359) {
          if (fullScreenLeft && fullScreenRight) {
            setDivTabWidth('910px');
            setDivRepWidth('91.7%');
          } else if (fullScreenLeft || fullScreenRight) {
            setDivTabWidth('705px');
            setDivRepWidth('90.5%');
          } else {
            setDivTabWidth('490px');
            setDivRepWidth('88%');
          }
        } else if (windowWidth >= 1360 && windowWidth <= 1439) {
          if (fullScreenLeft && fullScreenRight) {
            setDivTabWidth('940px');
            setDivRepWidth('91.5%');
          } else if (fullScreenLeft || fullScreenRight) {
            setDivTabWidth('690px');
            setDivRepWidth('90%');
          } else {
            setDivTabWidth('440px');
            setDivRepWidth('87%');
          }
        } else if (windowWidth >= 1440 && windowWidth <= 1599) {
          if (fullScreenLeft && fullScreenRight) {
            setDivTabWidth('1020px');
            setDivRepWidth('92%');
          } else if (fullScreenLeft || fullScreenRight) {
            setDivTabWidth('770px');
            setDivRepWidth('90.5%');
          } else {
            setDivTabWidth('520px');
            setDivRepWidth('88%');
          }
        } else if (windowWidth >= 1600 && windowWidth <= 1799) {
          if (fullScreenLeft && fullScreenRight) {
            setDivTabWidth('1180px');
            setDivRepWidth('92.7%');
          } else if (fullScreenLeft || fullScreenRight) {
            setDivTabWidth('880px');
            setDivRepWidth('91.2%');
          } else {
            setDivTabWidth('580px');
            setDivRepWidth('89%');
          }
        } else if (windowWidth >= 1800 && windowWidth <= 2559) {
          if (fullScreenLeft && fullScreenRight) {
            setDivTabWidth('1500px');
            setDivRepWidth('94%');
          } else if (fullScreenLeft || fullScreenRight) {
            setDivTabWidth('1150px');
            setDivRepWidth('92.5%');
          } else {
            setDivTabWidth('800px');
            setDivRepWidth('90.5%');
          }
        } else if (windowWidth >= 2560 && windowWidth <= 3839) {
          if (fullScreenLeft && fullScreenRight) {
            setDivTabWidth('2100px');
            setDivRepWidth('94%');
          } else if (fullScreenLeft || fullScreenRight) {
            setDivTabWidth('1750px');
            setDivRepWidth('92.5%');
          } else {
            setDivTabWidth('1400px');
            setDivRepWidth('90.5%');
          }
        } else if (windowWidth >= 3840) {
          if (fullScreenLeft && fullScreenRight) {
            setDivTabWidth('3250px');
            setDivRepWidth('94%');
          } else if (fullScreenLeft || fullScreenRight) {
            setDivTabWidth('2800px');
            setDivRepWidth('92.5%');
          } else {
            setDivTabWidth('2700px');
            setDivRepWidth('90.5%');
          }
        }
    }

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [fullScreenLeft, fullScreenRight]);

  const [divRepHeight, setDivRepHeight] = useState('75%');

  useEffect(() => {
    function handleResize() {
        const windowWidth = window.innerWidth;
        if (windowWidth >= 1280 && windowWidth <= 1359) {
          if (fullScreenLeft && fullScreenRight && listaReplicas.length > 5) {
            setDivRepHeight('72vh');
          } else if (!(fullScreenLeft && fullScreenRight) && listaReplicas.length > 3 ) {
            setDivRepHeight('72vh');
          } else {
            setDivRepHeight('79vh');
          }
        } else if (windowWidth >= 1360 && windowWidth <= 1439) {
          if (fullScreenLeft && fullScreenRight && listaReplicas.length > 5) {
            setDivRepHeight('71vh');
          } else if (!(fullScreenLeft && fullScreenRight) && listaReplicas.length > 3 ) {
            setDivRepHeight('71vh');
          } else {
            setDivRepHeight('77vh');
          }
        } else if (windowWidth >= 1440 && windowWidth <= 1599) {
          if (fullScreenLeft && fullScreenRight && listaReplicas.length > 5) {
            setDivRepHeight('74%');
          } else if (!(fullScreenLeft && fullScreenRight) && listaReplicas.length > 4 ) {
            setDivRepHeight('74vh');
          } else {
            setDivRepHeight('80vh');
          }
        } else if (windowWidth >= 1600 && windowWidth <= 1799) {
          if (fullScreenLeft && fullScreenRight && listaReplicas.length > 6) {
            setDivRepHeight('74vh');
          } else if (!(fullScreenLeft && fullScreenRight) && listaReplicas.length > 4 ) {
            setDivRepHeight('74vh');
          } else {
            setDivRepHeight('80vh');
          }
        } else if (windowWidth >= 1800 && windowWidth <= 2399) {
          if (fullScreenLeft && fullScreenRight && listaReplicas.length > 8) {
            setDivRepHeight('77vh');
          } else if (!(fullScreenLeft && fullScreenRight) && listaReplicas.length > 6 ) {
            setDivRepHeight('77vh');
          } else {
            setDivRepHeight('81vh');
          }
        } else if (windowWidth >= 2400 && windowWidth <= 3839) {
          if (fullScreenLeft && fullScreenRight && listaReplicas.length > 12) {
            setDivRepHeight('78vh');
          } else if (!(fullScreenLeft && fullScreenRight) && listaReplicas.length > 10 ) {
            setDivRepHeight('78vh');
          } else {
            setDivRepHeight('82vh');
          }
        } else if (windowWidth >= 3840) {
          if (fullScreenLeft && fullScreenRight && listaReplicas.length > 19) {
            setDivRepHeight('88vh');
          } else if (!(fullScreenLeft && fullScreenRight) && listaReplicas.length > 16 ) {
            setDivRepHeight('88vh');
          } else {
            setDivRepHeight('90vh');
          }
        }
    }

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [fullScreenLeft, fullScreenRight]);

  return (
    <div className='root-stage'>
        {mirrorActive === false &&
          <div style={{ display: 'flex', justifyContent: 'start !important', width: 'auto', marginTop:'-52px'}}>
          <Copilot/>
          </div>
          }
      <div
        className="container-replicates-tabs"
        style={{
          maxWidth: divTabWidth, 
          position: 'relative',
          margin: mirrorActive ? '0px 0 0 75px' : '0px 0 0 -15px',
        }}
        >
        {mirrorActive ?
          <div id={"mirror"} 
          className="mirrorTab-active">
            {fullScreenRight ?
            <CloseIcon
              style={{fill: '#FFFFFF', width: '18px', margin: '0 5px 0 0', cursor: "pointer"}}
              onClick={() => {
                if (replicaActive && listaReplicas.length > 0) {
                  setMirrorActive(!mirrorActive); 
                  setOpenReplicaContainer(!openReplicaContainer);
                  setFullScreenRight(!fullScreenRight);
                }
              }}/>
            :
            <CloseIcon
             style={{
              fill: '#FFFFFF', width: '18px', margin: '0 5px 0 0', cursor: "pointer"
              }}
              onClick={() => {
                if (replicaActive && listaReplicas.length > 0) {
                  setMirrorActive(!mirrorActive); 
                  setOpenReplicaContainer(!openReplicaContainer);
                }
              }}/>
            }
            <CompareIcon  style={{fill:'#FFFFFF'}}/>
          </div>
        : 
          <div 
            id={"mirror"} 
            onClick={() => {
              setMirrorActive(!mirrorActive); 
              setOpenReplicaContainer(!openReplicaContainer); 
              setFullScreenRight(!fullScreenRight);
            }} 
            className="mirrorTab">
            <CompareIcon style={{fill: '#68498C'}} />
          </div>
        }
        {listaReplicas.map((item, index) =>
          <div
            key={`LR-${item.width}x${item.height}-${index}i`}
            id={"aba_replica_" + item.width + "x" + item.height}
            onClick={() => { 
              setReplicaActive(`${item.width}x${item.height}`);
              setIsBannerActive(true);
              
              if (item.width > 700 && item.height > 700) {
                changePreviewZoom(0.4);
              } else {
                changePreviewZoom(1);
              }
            }} 
            className={replicaActive === `${item.width}x${item.height}` ? "container-tabs tab-active" : "container-tabs"}>
            <CloseIcon onClick={(evt) => removeReplica(item, index, evt)} style={{position:  'absolute', left: '12px', cursor: 'pointer'}}/>
            <span>{`${item.width}x${item.height}`}</span> 
            <input type='checkbox' style={{position: 'absolute', right: '20px', accentColor: '#68498C'}} checked={item.pack} onChange={() => null} onClick={() => handleChecked(item, index)}></input>
          </div>
        )}
        <div
          onClick={(e) => setTempLine('y')}
          className={`ruler x ${tempLine === 'y' ? 'ruler-on' : editGrid ? 'active' : ''}`}
          style={{ width: ruler.width }}
        >
          { rulerX_100 }
          { rulerX_10 }
        </div>
      </div>
      {mirrorActive ?
        <div className="container-replicates" style={{width: divRepWidth, maxWidth: divRepWidth, height: divRepHeight, transition: 'width 200ms'}}>
          <div className='copilot'>
            <div>
          <Copilot/>
            </div>
          </div>
          <div className='container-preview-master'>
            <Preview {...master} mirror={mirrorActive} type="master" />
          </div>
          {listaReplicas.length > 0 ?
          <div
            className="container-preview-replicas"
            style={{ display: listaReplicas.length > 0 ? 'flex' : 'none' }}>
         
            {listaReplicas.map((item, index) =>
             `${item.width}x${item.height}` === replicaActive ?
              <div
                className="container-preview-r"
                key={`replicate-${index}-${item.width}x${item.height}`}
                style={{ display: `${item.width}x${item.height}` === replicaActive ? 'flex' : 'none' }}>
                <div style={{display: item.estatico && !mirrorActive ? 'none' : 'flex'}}>
                  <Preview {...item} mirror={mirrorActive} active={replicaActive} type="replica" className="preview-container" />
                </div>
              </div> : <></>
            )}
          </div>
          :
          <span className='messageSelectFormat' style={{margin: '0 auto', lineHeight: '25px', fontSize: '16px'}}>Selecione um formato na coluna da esquerda<br/> para começar a trabalhar!</span>
          }
        </div>
        :
        <div
          className={"container-replicates-stages"}
          id={"container-replicates-stages"}
          style={{ position: editGrid ? 'relative' : 'static' }}
        >
         
          {listaReplicas.length > 0 ?
          <>
          <div>
            {listaReplicas.map((item, index) =>
             `${item.width}x${item.height}` === replicaActive ?
              <div className="container-preview-r"
                id={`id-container-preview-r-${item.width}x${item.height}`} 
                key={`listReplic-${item.width}x${item.height}-${index}`} 
                style={{ display: `${item.width}x${item.height}` === replicaActive ? 'flex' : 'none' }}>
                <div
                  onClick={() => setTempLine('x')}
                  className={`ruler y ${tempLine === 'x' ? 'ruler-on' : editGrid ? 'active' : ''}`}
                  style={{ height: ruler.height }}>
                  { rulerY_100 }
                  { rulerY_10 }
                </div>
                <div style={{display: item.estatico && !mirrorActive ? 'none' : 'flex', flexDirection: 'column', justifyContent: 'center', margin: "auto"}}>
                  <span style={{color: 'black', 
                    fontSize: '21px', 
                    fontWeight: 'bold', 
                    display: 'flex', 
                    alignSelf: "center",
                    marginTop: !mirrorActive ? '30px' : '' 
                  }}>
                    Preview
                  </span>
                  <div style={{display: 'flex', alignItems: 'center', flexDirection: 'column'}}>
                    <Preview {...item} mirror={mirrorActive} active={replicaActive} type="previewReplica" className="preview-container" />
                  </div>
                </div>
              { openReplicaContainer ?
              <div style={{width: '100%'}}>
                {item ?
                <Stages {...item}></Stages>
                : <></>
              }
              </div> : <></>
              }
              </div>
              : <></>
            )}
          </div>
            </>
          :
          <div className='containerEmptyFormat'>Selecione um formato para habilitar as propriedades e começar a trabalhar!</div>
          }
        </div>
      }
    </div>
  )
}

export default Replicates;